import React from 'react';
import { useOutletContext } from 'react-router-dom';

/**
 * Full-page empty state for Campaign and Reporting screens when the
 * organization has no clients, or a client exists but none is selected.
 * Stays blank until the campaign list has loaded so a slow fetch does not
 * flash "no clients" or a skeleton.
 */
export default function NoClientState() {
  const { campaigns, campaignsLoaded } = useOutletContext();
  if (!campaignsLoaded) {
    return <div className="aivis-no-client" aria-busy="true" />;
  }

  const hasClients = (campaigns || []).length > 0;
  const title = hasClients ? 'No client selected' : 'No clients available';
  const detail = hasClients
    ? 'Select a client from the sidebar to see data here.'
    : 'Add a client to see data here.';

  return (
    <div className="aivis-no-client">
      <div className="aivis-no-client-inner">
        <div className="aivis-no-client-icon" aria-hidden>
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
            <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
            <circle cx="9" cy="7" r="4" />
            <line x1="19" y1="8" x2="19" y2="14" />
            <line x1="22" y1="11" x2="16" y2="11" />
          </svg>
        </div>
        <h1 className="aivis-no-client-title">{title}</h1>
        <p className="aivis-no-client-text">{detail}</p>
      </div>
    </div>
  );
}
